<script setup lang="ts">
import type { IconName } from "@/shared/@types/IconName";
import type { InfoboxStatus } from "@/shared/@types/InfoboxStatus";
import Icon from "../Icon/Icon.vue";

defineProps<{
  status: InfoboxStatus;
  withoutIcon?: boolean;
}>();

const iconNameByStatus: Record<InfoboxStatus, IconName> = {
  success: "checkCircleFilled",
  warning: "warningFilled",
  error: "errorFilled",
  info: "infoFilled",
};

const getIconNameByStatus = (status: InfoboxStatus): IconName =>
  iconNameByStatus[status];
</script>

<template>
  <div
    class="infobox"
    :data-status="status"
  >
    <Icon
      v-if="!withoutIcon"
      :size="20"
      :icon="getIconNameByStatus(status)"
      class="infobox--icon"
    />
    <div class="infobox--content">
      <slot></slot>
    </div>
  </div>
</template>

<style scoped>
@import "Infobox.css";
</style>
